import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { CARD_EXPORT_IFRAME_AUTH_REQUIRED_TYPE } from '~/functions/client-card-export';
export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth;
    var router = useRouter();
    var waitForAuthReady = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var attempt;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              attempt = 0;
            case 1:
              if (!(attempt < 40)) {
                _context.next = 9;
                break;
              }
              if ($auth.loading) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.next = 6;
              return new Promise(function (resolve) {
                return window.setTimeout(resolve, 50);
              });
            case 6:
              attempt += 1;
              _context.next = 1;
              break;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function waitForAuthReady() {
        return _ref.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var redirect;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(typeof window !== 'undefined' && window.self !== window.top)) {
              _context2.next = 3;
              break;
            }
            window.parent.postMessage({
              type: CARD_EXPORT_IFRAME_AUTH_REQUIRED_TYPE
            }, window.location.origin);
            return _context2.abrupt("return");
          case 3:
            _context2.next = 5;
            return waitForAuthReady();
          case 5:
            if (!$auth.loggedIn) {
              _context2.next = 11;
              break;
            }
            redirect = $auth.$storage.getUniversal('redirect') || '/';
            $auth.$storage.removeUniversal('redirect');
            _context2.next = 10;
            return router.replace(redirect);
          case 10:
            return _context2.abrupt("return");
          case 11:
            _context2.next = 13;
            return $auth.loginWith('auth0');
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return {
      __sfc: true,
      $auth: $auth,
      router: router,
      waitForAuthReady: waitForAuthReady
    };
  }
});